import React, { useEffect, useRef, memo, useMemo } from "react";
import ApexCharts from "apexcharts";
import { useSelector } from "react-redux";
const StackedBarChart = ({
  icon,
  title,
  title1,
  categories,
  series,
  colors,
  heading,
  height,
  titles,
}) => {
  const chartRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  //console.log(isPermissionCompleted, "isPermissionCompleted");

  useEffect(() => {
    if (chartRef.current) {
      const options = {
        chart: {
          type: "bar",
          stacked: true,

          height: height || 350,
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: "11px",
                  fontWeight: "normal",
                  colors: ["#333"],
                },
                formatter: function (val) {
                  return parseFloat(val.toFixed(2));
                },
              },
            },
          },
        },
        colors: colors,
        series: series,
        xaxis: {
          categories: categories,
          title: {
            text: "Month",
            style: { fontSize: "11px", color: "#000", fontWeight: "normal" },
          },
          labels: {
            style: { fontSize: "11px", color: "#000", fontWeight: "normal" },
          },
          axisBorder: { show: true, color: "#000" },
        },
        yaxis: {
          title: {
            text: "in MtCO2e",
            style: { fontSize: "11px", color: "#000", fontWeight: "normal" },
          },
          labels: {
            style: { fontSize: "11px", color: "#000", fontWeight: "normal" },
            formatter: (value) => {
              if (value === 0) return "0";
              if (Math.abs(value) < 10)
                return Number(value.toFixed(2)).toLocaleString("en-IN");
              return Math.round(value).toLocaleString("en-IN");
            },
          },
          decimalsInFloat: 1,
          axisBorder: { show: true, color: "#000" },
        },
        grid: {
          yaxis: { lines: { show: false } },
          xaxis: { lines: { show: false } },
        },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          markers: { width: 10, height: 10 },
          fontSize: "11px",
        },
        fill: { opacity: 1 },
        tooltip: {
          y: {
            formatter: function (value) {
              return value != null ? value.toString() : value;
            },
          },
        },
        dataLabels: { enabled: false },
        states: {
          hover: { filter: { type: "none" } },
          active: { filter: { type: "none" } },
        },

        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },

        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: {
                height: 300,
              },
              legend: {
                position: "bottom",
              },
            },
          },
          {
            breakpoint: 480,
            options: {
              chart: {
                height: 260,
              },
              plotOptions: {
                bar: {
                  columnWidth: "60%",
                },
              },
              xaxis: {
                labels: {
                  rotate: -45,
                  style: { fontSize: "10px" },
                },
              },
              yaxis: {
                labels: {
                  style: { fontSize: "10px" },
                },
              },
              legend: {
                fontSize: "10px",
              },
            },
          },
        ],
      };

      const chart = new ApexCharts(chartRef.current, options);
      chart.render();

      return () => chart.destroy();
    }
  }, [categories, series, colors, height]);

  return (
    <div className="px-4 sm:px-6 md:px-8 pt-6 md:pt-8 w-full">
      <div className="flex items-center gap-2 justify-start mb-2">
        {heading || titles ? (
          <>
            <h2 className="text-left font-bold text-sm md:text-base text-[#06513D] ">
              {heading}
            </h2>
            <h2 className="text-left font-bold text-[#06513D] text-sm md:text-base">
              {titles}
            </h2>
          </>
        ) : (
          <h2 className="text-left font-bold text-sm md:text-base text-transparent select-none">
            &nbsp;
          </h2>
        )}
      </div>
      <div className="flex items-center gap-2 justify-start mb-4 min-h-[48px]">
        <span className="text-[#06513D] text-2xl md:text-3xl flex-shrink-0">
          {icon}
        </span>
        <div className="min-w-0">
          <h2 className="capitalize font-bold text-sm md:text-base font-[Calibri] text-[#06513D] leading-tight">
            {title}
          </h2>
          {title1 && (
            <h4 className="text-[#263238] font-light text-xs md:text-sm leading-[100%] font-[Calibri]">
              {title1}
            </h4>
          )}
        </div>
      </div>
      <div
        className={` ${
          !isPermissionCompleted ? "blur-sm opacity-60 pointer-events-none" : ""
        }`}
        ref={chartRef}
      />
    </div>
  );
};

export default memo(StackedBarChart);
